import {
  MarkupAmountType,
  TaxAmountType,
  PriceInput,
} from 'lane-shared/domains/billingPayments/types';
import { AdminFeeAmountType } from 'application-types';
import { PriceComponents } from 'lane-shared/domains/productCatalog/types';

export function priceInputToComponents(
  priceInput: PriceInput
): PriceComponents {
  const { rate, markup, tax, adminFee, netPrice } = priceInput;

  return {
    amount: Number(rate),
    markup: {
      value: Number(markup?.value || 0),
      markupAmountType:
        markup?.type || MarkupAmountType.MarkupAmountTypePercentage,
    },
    adminFee: {
      value: Number(adminFee?.value || 0),
      adminFeeAmountType:
        adminFee?.type || AdminFeeAmountType.AdminFeeAmountTypePercentage,
    },
    tax: {
      value: Number(tax?.value || 0),
      taxAmountType: tax?.type || TaxAmountType.TaxAmountTypePercentage,
    },
    netPrice: Number(netPrice),
  };
}
